import React, { useState, useEffect } from "react";
import {
  Box,
  Container,
  Paper,
  Typography,
  Avatar,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Chip,
  Grid,
  IconButton,
  styled,
  alpha,
} from "@mui/material";
import stich from "./Plan/Cafe.jpeg";

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  position: "relative",
  overflow: "hidden",
}));

const StyledAvatar = styled(Avatar)(({ theme }) => ({
  width: 128,
  height: 128,
  border: `4px solid ${theme.palette.background.paper}`,
}));

const Profile = () => {
  const [open, setOpen] = useState(false);
  const [userInfo, setUserInfo] = useState({
    name: "",
    email: "",
    location: "",
    memberSince: "",
    completedProjects: 0,
    contributedHours: 0,
    badges: [],
  });
  const [avatar, setAvatar] = useState(null);

  useEffect(() => {
    const whoami = JSON.parse(localStorage.getItem("whoami")) || {};
    setUserInfo({
      name: (whoami.name + " " + whoami.lastname) || "Usuario",
      email: whoami.email || "correo@example.com",
      location: whoami.country || "Desconocido",
      memberSince: "2025",
      completedProjects: 42,
      contributedHours: 3256,
      badges: ["Admin", "Usuario Premium"],
    });
  }, []);

  return (
    <Box sx={{ py: 4 }}>
      <Container maxWidth="lg">
        <StyledPaper elevation={2}>
          <Grid container spacing={3} alignItems="flex-start">
            <Grid item xs={12} md="auto">
              <StyledAvatar
                src={
                  avatar ||
                  "https://static.vecteezy.com/system/resources/previews/019/879/186/non_2x/user-icon-on-transparent-background-free-png.png"
                }
                alt={userInfo.name}
              />
            </Grid>

            <Grid item xs={12} md>
              <Typography variant="h4" fontWeight="bold">
                {userInfo.name}
              </Typography>
              <Typography color="text.secondary">{userInfo.email}</Typography>
              <Typography color="text.secondary">
                {userInfo.location}
              </Typography>
            </Grid>
          </Grid>
        </StyledPaper>
      </Container>
    </Box>
  );
};

export default Profile;
